import { render } from "./EditStatus.vue?vue&type=template&id=7c2ea9a5&ts=true"
import script from "./EditStatus.vue?vue&type=script&lang=ts"
export * from "./EditStatus.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__